import { assign, pairs, values } from 'lodash';

// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
if (!Object.assign) {
  Object.assign = assign;
}

// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/values
// Caution: Object.values('foo') does not work with this implementation
if (!Object.values) {
  Object.values = values;
}

// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/entries
if (!Object.entries) {
  Object.entries = pairs;
}
